/**
 * Shown ONLY if GET /api/candidates/legal-docs fails (note: the backend returns
 * 500 when nothing has been published yet). Once an admin publishes the real
 * document from the admin portal, this text is never seen.
 */
export const LEGAL_FALLBACK = `# छत्रपती सेवा प्रतिष्ठान नागपूर-पुणे पुरस्कृत

# शिवकथाकार श्री विजयराव देशमुख शिव-वक्ता स्पर्धा
२०२६-२७

## स्पर्धेची माहिती आणि नियमावली

### स्पर्धेचा उद्देश

छत्रपती शिवाजी महाराजांचा तेजस्वी इतिहास, त्यांचे विचार आणि मूल्ये आजच्या विद्यार्थी
व युवा पिढीने अभ्यासावी, आत्मसात करावी आणि आपल्या वक्तृत्वाद्वारे ती समाजापर्यंत
पोहोचवावीत, या उदात्त हेतूने शिवसेवेत सदैव अग्रणी असलेल्या छत्रपती सेवा प्रतिष्ठानने
शिवकथाकार श्री. विजयराव देशमुख ‘शिव-वक्ता स्पर्धा २०२६-२७’ चे आयोजन केले आहे.

शिवचरित्राच्या अभ्यासातून विद्यार्थ्यांना राष्ट्रभक्ती, मातृ-पितृभक्ती, ध्येयनिष्ठा,
नेतृत्वगुण, शौर्य आणि संघटन कौशल्यादि अनेक शिवगुणांची प्रेरणा मिळते. अशा अभ्यासु
विद्यार्थ्यांना त्यांची वक्तृत्वकला, विचार मांडण्याची क्षमता आणि आत्मविश्वास विकसित
करण्यासाठी ही स्पर्धा एक अत्यंत उपयुक्त व्यासपीठ आहे.

### स्पर्धकांची नोंदणी

1.  स्पर्धकांना या स्पर्धेची निशुल्क नोंदणी छत्रपती सेवा प्रतिष्ठानच्या अधिकृत
    संकेतस्थळावर
    ([https://chatrapatisevapratishthan.org](https://chatrapatisevapratishthan.org))
    करायची आहे

2.  स्पर्धकांची नोंदणी घटस्थापना, दिनांक ११ ऑक्टोबर ते २० नोव्हेंबर २०२६ या दरम्यान
    करता येईल. या नंतर केलेली नोंदणी ग्राह्य ठरली जाणार नाही.

3.  स्पर्धेत भाग घेण्यासाठी पूर्व नोंदणी बंधनकारक आहे. ऐन वेळी येणाऱ्या स्पर्धकांना
    सहभाग घेता येणार नाही.

4.  स्पर्धेच्या ठिकाणी सहभागी स्पर्धक शाळा महाविद्यालयाचे स्वत:चा फोटो असलेले
    ओळखपत्र अथवा आधार कार्ड आणि छत्रपती सेवा प्रतिष्ठानच्या संकेतस्थळावर नोंदणी पूर्ण
    झाल्यावर मिळालेला ID पडताळणीसाठी देतील. जिल्हा स्तरावरील स्पर्धेच्या ठिकाणी
    शालेय/महाविद्यालयाचे विजेते विद्यार्थी शाळा महाविद्यालयाचे पत्र सादर करतील.
    पूर्व पडताळणी शिवाय सहभागी होता येणार नाही.

### स्पर्धेचे स्वरूप

शिवकथाकार श्री विजयराव देशमुख शिववक्ता स्पर्धा राज्यस्तरावर महाराष्ट्रातील सहा
विभागांमध्ये (मुंबई – कोकण विभाग, पश्चिम महाराष्ट्र - पुणे विभाग, उत्तर महाराष्ट्र -
नाशिक विभाग, मराठवाडा – छत्रपती संभाजी नगर विभाग, पूर्व विदर्भ– अमरावती विभाग
आणि पश्चिम विदर्भ – नागपुर विभाग) घेतली जाईल.

स्पर्धा दोन गटांत होईल –

1.  **पहिला गट - शालेय गट -** वय वर्षे १८ पर्यंत.

    1.  या गटात १ जानेवारी २००९ किंवा त्यानंतर ज्यांची जन्मतारीख आहे ते या गटात
        नोंदणी करू शकतात. स्पर्धकाच्या आधार कार्डवर नमूद केलेली जन्मतारीख ग्राह्य
        धरली जाईल.

    2.  या गटात प्रामुख्याने माध्यमिक, उच्च माध्यमिक शाळा/महाविद्यालयातील
        विद्यार्थ्यांचा सहभाग अपेक्षित आहे

    3.  स्पर्धाच्या चार फेऱ्या होतील

        1.  **पहिली फेरी (पात्रता फेरी)**

            1.  ज्या शाळेतून/महाविद्यालयातून स्पर्धकांनी नोंदणी केली आहे त्याच
                शाळेत/महाविद्यालयात ही पात्रता फेरी संपन्न होईल.

            2.  प्रत्येक शाळेतून विजेते दोन विद्यार्थी पुढल्या जिल्हा स्तरावरील
                फेरीसाठी पात्र ठरतील.

            3.  ही फेरी संबंधित शाळेने/महाविद्यालयाने अंतर्गत परीक्षक नेमून घ्यायची
                आहे.

            4.  पहिली फेरी १ ते १० डिसेंबर २०२६ दरम्यान किंवा शाळेच्या अंतर्गत
                वेळापत्रकानुसार संपन्न होईल.

        2.  **दुसरी फेरी (उप-उपांत्य फेरी)**

            1.  ही उप-उपांत्य फेरी जिल्हा स्तरावर होईल. शाळा/महाविद्यालयातील
                पात्रता फेरीतील प्रत्येकी २ विजेते या फेरीसाठी पात्र ठरतील.

            2.  ज्या जिल्ह्यात स्पर्धकाची शाळा/महाविद्यालय असेल त्या जिल्ह्याच्या
                ठिकाणी ही फेरी घेतल्या जाईल.

            3.  ही फेरी छत्रपती सेवा प्रतिष्ठान निष्पक्ष आणि स्वतंत्र परीक्षक नेमून
                घेईल.

            4.  ही फेरी २१ ते ३० डिसेंबर २०२६ दरम्यान घेतली जाईल.

            5.  पहिल्या फेरीतील विजेत्यांना स्पर्धेचे स्थान, स्पर्धेची तारीख आणि वेळ
                स्वतंत्रपणे कळविली जाईल.

            6.  स्पर्धास्थाना पर्यंत जाण्यायेण्याचा आणि राहण्याचा/जेवणाचा खर्च
                स्पर्धकाला करावा लागेल.

        3.  **तिसरी फेरी (उपांत्य फेरी)**

            1.  ही उपांत्य फेरी विभाग स्तरावर होईल. उप-उपांत्य फेरीतील ३ विजेते
                या फेरीसाठी पात्र ठरतील

            2.  ज्या जिल्ह्यात स्पर्धकाची शाळा/महाविद्यालय असेल त्या जिल्ह्याच्या
                विभाग स्थळी ही फेरी घेतल्या जाईल.

            3.  ही फेरी छत्रपती सेवा प्रतिष्ठान निष्पक्ष आणि स्वतंत्र परीक्षक नेमून
                घेईल.

            4.  ही फेरी ५ ते १२ जानेवारी २०२७ दरम्यान विभाग मुख्यालय असलेल्या
                शहरात घेतली जाईल. उपांत्य फेरी (विभागीय फेरी) सहा विभागात
                होईल -

                1.  नागपूर येथे (पूर्व विदर्भातील नागपूर, वर्धा, भंडारा, गोंदिया,
                    चंद्रपूर आणि गडचिरोली जिल्हा)

                2.  अमरावती येथे (पश्चिम विदर्भातील अमरावती, अकोला, बुलढाणा,
                    वाशीम, यवतमाळ जिल्हा)

                3.  छत्रपती संभाजीनगर येथे (मराठवाड्याल छ. संभाजीनगर, जालना,
                    बीड, परभणी, हिंगोली, नांदेड, लातूर, धाराशिव जिल्हा)

                4.  नाशिक येथे (उत्तर महाराष्ट्रातील नाशिक, धुळे, जळगाव,
                    नंदुरबार, अहिल्यानगर जिल्हा)

                5.  पुणे येथे (पश्चिम महाराष्ट्रातील पुणे, सातारा, सांगली,
                    कोल्हापूर, सोलापूर जिल्हा)

                6.  मुंबई येथे (मुंबई आणि कोकण येथील मुंबई, ठाणे, पालघर, रायगड,
                    रत्नागिरी, सिंधुदुर्ग जिल्हा)

            5.  दुसर्‍या म्हणजे उप-उपांत्य फेरीतील विजेत्यांना स्पर्धेचे स्थान, स्पर्धेची
                तारीख आणि वेळ स्वतंत्रपणे कळविली जाईल.

            6.  स्पर्धास्थाना पर्यंत जाण्यायेण्याचा आणि राहण्याचा/जेवणाचा खर्च
                स्पर्धकाला करावा लागेल.

        4.  **अंतिम फेरी**

            1.  प्रत्येक विभागातून उपांत्य फेरीतील २ विजेते या अंतिम फेरीसाठी पात्र
                ठरतील.

            2.  अंतिम फेरी दिनांक २७ व २८ जानेवारी २०२७ रोजी औदुंबरवाडी, भांबेरी
                (ता. तेल्हारा, जि. अकोला) येथे संपन्न होईल.

            3.  उपांत्य फेरीतील विजेत्यांना त्यांचा निकाल स्वतंत्रपणे कळविला जाईल.

            4.  अंतिम फेरीतील पात्र स्पर्धकांचा त्यांच्या राहत्या गावाच्या रेल्वेच्या
                नजीकच्या रेल्वेस्थानाकावरून शेगाव/अकोला स्थानकापर्यंत स्लीपरक्लासचा
                जाण्यायेण्याच्या तिकिटाचा खर्च प्रतिष्ठान करेल. तिकीट स्पर्धकाला
                काढायचे आहे. तसेच भांबेरी येथे स्पर्धा काळात राहण्याची आणि जेवणाची
                व्यवस्था प्रतिष्ठान करेल.

        5.  स्पर्धेतील सर्व फेरीतील विजेत्यांची नावे छत्रपती सेवा प्रतिष्ठानच्या
            संकेतस्थळावर जाहीर केले जातील तसेच सर्व यशस्वी स्पर्धकांना स्वतंत्रपणे
            कळविले जातील.

    4.  स्पर्धकांना सादरीकरणासाठी अवधी –५ + १ मिनिटे

    5.  **स्पर्धेतील पुरस्कार – अंतिम फेरीतील विजेत्यांना**

        1.  पहिला पुरस्कार – रु २१,०००

        2.  द्वितीय पुरस्कार – रु ११,०००

        3.  तृतीय पुरस्कार – रु ५,०००

        4.  तसेच विभाग स्तरावर उत्कृष्ट स्पर्धकांना उत्तेजनार्थ पुरस्कार – रु १,०००

    6.  **पहिल्या गटातील स्पर्धेचे विषय**

> १. छत्रपती शिवाजी महाराजांची मातृभक्ती
>
> २. शिवचातुर्य - आग्र्याहून सुटका
>
> ३. शिवप्रताप - अफझल खान वध
>
> ४. माझा आवडता शिवदुर्ग
>
> ५. सदा स्मरावे जिजाऊ नाम
>
> ६. शिवरायांचा गनिमी कावा

7.  स्पर्धकांना वर दिलेल्या विषयातील कुठलाही विषय निवडण्याचे स्वातंत्र्य आहे. प्रत्येक
    फेरीत या यादीतील विषय बदलण्याचे स्वातंत्र्य राहील.

<!-- -->

2.  **दूसरा गट –महाविद्यालयीन आणि खुला गट -** वय
    वर्षे १८ ते ४५ पर्यन्त

    1.  या गटात १ जानेवारी १९८२ ते ३१ डिसेंबर २००८ दरम्यान ज्यांची जन्मतारीख आहे
        ते या गटात नोंदणी करू शकतात. स्पर्धकाच्या आधार कार्डवर नमूद केलेली
        जन्मतारीख ग्राह्य धरली जाईल.

    2.  प्रामुख्याने महाविद्यालयातील विद्यार्थ्यांचा तसेच नोकरी, व्यवसाय करणारे
        शिवभक्त, शिवचरित्र अभ्यासकांचा सहभाग अपेक्षित आहे

    3.  स्पर्धाच्या चार फेऱ्या होतील

        1.  **पहिली फेरी (पात्रता फेरी)**

            1.  ज्या महाविद्यालयातून/शहरातून/गावातून स्पर्धकांनी नोंदणी केली आहे
                त्या महाविद्यालयात/जवळच्या केंद्रात ही पात्रता फेरी संपन्न होईल.

            2.  प्रत्येक स्पर्धा केंद्रातून दोन विजेते स्पर्धक पुढल्या जिल्हा स्तरावरील
                फेरीसाठी पात्र ठरतील.

            3.  ही फेरी संबंधित महाविद्यालयाने/केंद्राने अंतर्गत परीक्षक नेमून घ्यायची
                आहे.

            4.  पहिली फेरी १ ते १० डिसेंबर २०२६ दरम्यान संपन्न होईल.

        2.  **दुसरी फेरी (उप-उपांत्य फेरी)**

            1.  ही उप-उपांत्य फेरी जिल्हा स्तरावर होईल. पात्रता फेरीतील प्रत्येकी
                २ विजेते या फेरीसाठी पात्र ठरतील

            2.  ज्या जिल्ह्यात स्पर्धकाचे महाविद्यालय/जेथे नोंदणी केली असेल त्या
                जिल्ह्याच्या ठिकाणी ही फेरी घेतल्या जाईल.

            3.  ही फेरी छत्रपती सेवा प्रतिष्ठान निष्पक्ष आणि स्वतंत्र परीक्षक नेमून
                घेईल.

            4.  ही फेरी २१ ते ३० डिसेंबर २०२६ दरम्यान घेतली जाईल.

            5.  पहिल्या फेरीतील विजेत्यांना स्पर्धेचे स्थान, स्पर्धेची तारीख आणि वेळ
                स्वतंत्रपणे कळविली जाईल.

            6.  स्पर्धास्थाना पर्यंत जाण्यायेण्याचा आणि राहण्याचा/जेवणाचा खर्च
                स्पर्धकाला करावा लागेल.

        3.  **तिसरी फेरी (उपांत्य फेरी)**

            1.  ही उपांत्य फेरी विभाग स्तरावर होईल. उप-उपांत्य फेरीतील ३ विजेते
                या फेरीसाठी पात्र ठरतील

            2.  ज्या जिल्ह्यात स्पर्धकाचे महाविद्यालय/जेथे नोंदणी केली असेल त्या
                जिल्ह्याच्या विभाग स्थळी ही फेरी घेतल्या जाईल.

            3.  ही फेरी छत्रपती सेवा प्रतिष्ठान निष्पक्ष आणि स्वतंत्र परीक्षक नेमून
                घेईल.

            4.  ही फेरी ५ ते १२ जानेवारी २०२७ दरम्यान विभाग मुख्यालय असलेल्या
                शहरात घेतली जाईल. उपांत्य फेरी (विभागीय फेरी) सहा विभागात
                होईल -

                1.  नागपूर येथे (पूर्व विदर्भातील नागपूर, वर्धा, भंडारा, गोंदिया,
                    चंद्रपूर आणि गडचिरोली जिल्हा)

                2.  अमरावती येथे (पश्चिम विदर्भातील अमरावती, अकोला, बुलढाणा,
                    वाशीम, यवतमाळ जिल्हा)

                3.  छत्रपती संभाजीनगर येथे (मराठवाड्यातील छ. संभाजीनगर, जालना,
                    बीड, परभणी, हिंगोली, नांदेड, लातूर, धाराशिव जिल्हा)

                4.  नाशिक येथे (उत्तर महाराष्ट्रातील नाशिक, धुळे, जळगाव,
                    नंदुरबार, अहिल्यानगर जिल्हा)

                5.  पुणे येथे (पश्चिम महाराष्ट्रातील पुणे, सातारा, सांगली,
                    कोल्हापूर, सोलापूर जिल्हा)

                6.  मुंबई येथे (मुंबई आणि कोकण येथील मुंबई, ठाणे, पालघर, रायगड,
                    रत्नागिरी, सिंधुदुर्ग जिल्हा)

            5.  दुसर्‍या म्हणजे उप-उपांत्य फेरीतील विजेत्यांना स्पर्धेचे स्थान, स्पर्धेची
                तारीख आणि वेळ स्वतंत्रपणे कळविली जाईल.

            6.  स्पर्धास्थाना पर्यंत जाण्यायेण्याचा आणि राहण्याचा/जेवणाचा खर्च
                स्पर्धकाला करावा लागेल.

        4.  **अंतिम फेरी**

            1.  प्रत्येक विभागातून उपांत्य फेरीतील २ विजेते या अंतिम फेरीसाठी पात्र
                ठरतील.

            2.  अंतिम फेरी दिनांक २७ व २८ जानेवारी २०२७ रोजी औदुंबरवाडी, भांबेरी
                (ता. तेल्हारा, जि. अकोला) येथे संपन्न होईल.

            3.  उपांत्य फेरीतील विजेत्यांना त्यांचा निकाल स्वतंत्रपणे कळविला जाईल.

            4.  अंतिम फेरीतील पात्र स्पर्धकांचा त्यांच्या राहत्या गावाच्या रेल्वेच्या
                नजीकच्या रेल्वेस्थानाकावरून शेगाव/अकोला स्थानकापर्यंत स्लीपरक्लासचा
                जाण्यायेण्याच्या तिकिटाचा खर्च प्रतिष्ठान करेल. तिकीट स्पर्धकाला
                काढायचे आहे. तसेच भांबेरी येथे स्पर्धा काळात राहण्याची आणि जेवणाची
                व्यवस्था प्रतिष्ठान करेल.

        5.  स्पर्धेतील सर्व फेरीतील विजेत्यांची नावे छत्रपती सेवा प्रतिष्ठानच्या
            संकेतस्थळावर जाहीर केले जातील, तसेच सर्व यशस्वी स्पर्धकांना स्वतंत्रपणे
            कळविले जातील.

    4.  स्पर्धकांना सादरीकरणासाठी अवधी –८ + २ मिनिटे

    5.  **स्पर्धेतील पुरस्कार – अंतिम फेरीतील विजेत्यांना**

        1.  पहिला पुरस्कार – रु ५१,०००

        2.  द्वितीय पुरस्कार – रु २१,०००

        3.  तृतीय पुरस्कार – रु ११,०००

        4.  तसेच विभाग स्तरावर उत्कृष्ट स्पर्धकांना उत्तेजनार्थ पुरस्कार – रु २,०००

    6.  **दुसऱ्यागटातील स्पर्धेचे विषय**

> १. शिवपूर्वकालीन भारत
>
> २. शिवराजाभिषेकाचे महत्व
>
> ३. हिंदवी स्वराज्याचे प्रशासन
>
> ४. शिवचरित्र आणि आजचा भारत
>
> ५. सदा असावे शिवमय जीवन
>
> ६. महिला सशक्तीकरण आणि महाराज
>
> स्पर्धकांना वर दिलेल्या विषयातील कुठलाही विषय निवडण्याचे स्वातंत्र्य आहे. प्रत्येक
> फेरीत या यादीतील विषय बदलण्याचे स्वातंत्र्य राहील.

**स्पर्धकांच्या परीक्षणाचे निकष**

> दोन्ही गटातील स्पर्धकांच्या वक्तृत्व परीक्षणाचे निकष खालील प्रमाणे असतील –

|        |                          |
|--------|--------------------------|
| **क्र** | **वक्तृत्व मूल्यमापनाचे निकष** |
|        |                          |
| १      | विषयाची प्रस्तावना         |
| २      | विषयाची सुसूत्र बांधणी       |
| ३      | अभ्यासयुक्त सादरीकरण        |
| ४      | वैचारिक स्पष्टता            |
| ५      | भाषणातील अस्खलितपणा       |
| ६      | ऐतिहासिक संदर्भ            |
| ७      | आत्मविश्वास, स्पष्ट उच्चार    |
| ८      | आवाजातील चढ-उतार         |
| ९      | प्रेक्षकांशी संवाद            |
| १०     | विषयाचा शेवट/बोधसेवन       |

**नियमावली -**

1.  प्राथमिक फेरी महाविद्यालय, शहर किंवा जिल्हा स्तरावर होईल. विभागीय फेरी त्या
    त्या विभागात होईल.

2.  स्पर्धेच्या फेरीचे स्थळ, तारीख आणि वेळ छत्रपती सेवा प्रतिष्ठानच्या संकेत स्थळावर
    जाहीर होईल तसेच यशस्वी स्पर्धकांना त्यांच्या e-mail id वर स्वतंत्रपणे कळविण्यात
    येईल. सर्व स्पर्धकांनी स्पर्धेच्या प्रत्येक फेरीनंतर आपला e-mail आणि छत्रपती सेवा
    प्रतिष्ठानचे संकेत स्थळ वारंवार तपासावे. या संदर्भातील माहिती न मिळाल्यास
    छत्रपती सेवा प्रतिष्ठान जबाबदार राहणार नाही.

3.  विभाग स्तरावरील स्पर्धा फेरीपर्यंत (उपांत्य फेरी पर्यंत) त्या स्थानापर्यंत
    जाण्यायेण्याचा, राहण्याचा, भोजनाचा सर्व खर्च स्पर्धकाला करावा लागेल.

4.  स्पर्धेसाठी स्पर्धकांची नोंदणी घटस्थापना, दिनांक ११ ऑक्टोबर ते २० नोव्हेंबर २०२६
    या दरम्यान करता येईल. या नंतर केलेली नोंदणी ग्राह्य ठरली जाणार नाही.

5.  पूर्व नोंदणी बंधनकारक. ऐन वेळी येणाऱ्या स्पर्धकांना सहभाग घेता येणार नाही.

6.  सादरीकरण कालावधी

    1.  शालेय गट ५ + १ मिनिटे

    2.  खुला गट ८ + २ मिनिटे

7.  स्पर्धक मराठी, हिंदी किंवा इंग्रजी यापैकी कुठल्याही एका भाषेतून विषय मांडू शकेल.
    भाषेची निवड आधी कळवावी लागेल.

8.  स्पर्धा पूर्णपणे दोन्ही गटांसाठी निःशुल्क आहे.

9.  संदर्भासाठी प्रमाणित शिवचरित्र ग्राह्य धरले जाईल. त्यात "शककर्ते शिवराय" हे
    शिवचरित्र अग्रणी असेल.

10. मूल्यांकन करताना परीक्षक मंडळ संदर्भासहित सत्य इतिहास कथनास सर्वाधिक महत्व
    देईल. भाषा आणि वक्तृत्व शैली, आवश्यक देहबोली, श्रोत्यांवर होणारा परिणाम आणि
    वक्तृत्वातून दिला जाणारा सकारात्मक संदेश किंवा बोध, असे किंवा अन्य वेळेवर परीक्षक
    मंडळ ठरवेल असे निकष यासाठीही स्वतंत्र मूल्यांकन होईल.

11. परीक्षकांचा निर्णय अंतिम राहील.

12. पारितोषिक विभागून दिले जाणार नाही. तशीच वेळ आल्यास परीक्षक नवा विषय देऊन
    तिथल्या तिथेच ऐनवेळी बोलण्यासाठी अतिरिक्त वेळ देतील.

13. स्पर्धेच्या नियमात ऐनवेळी बदल करण्याचा अधिकार संयोजकांकडे राहील.

14. सामाजिक ऐक्य आणि पूजनीय श्रद्धास्थानांचा, व्यक्तिमत्वांचा आदर देऊन वक्त्यांनी विषय
    मांडणे अपेक्षित आहे. कुठलाही धर्म, संप्रदाय, जात, संत - सत्पुरुष, धार्मिक पूजा आणि
    श्रद्धास्थानांचा द्वेष मूलक अनादर करणारे वक्तव्य केले तर तो स्पर्धक संपूर्ण स्पर्धेसाठी
    अपात्र होईल.

15. सर्व विवाद नागपूर न्याय पालिकेच्या अंतर्गत राहतील.
`;
